module.exports = __webpack_public_path__ + "img/17.9d00b3c7.png";